export const FLOATING_UI_DOM_ID = 'floating-ui-portal';
export const TOAST_DOM_ID = 'toast-portal';

// Default space / size values for fLoating panels
export const PANEL_DEFAULTS = {
  anchorOffset: 8,
  arrowHeight: 8, // This match the $arrow-width param on the dialogs.arrow scss mixin
  arrowHeightSmall: 6,
  windowEdgePadding: 8,
};
